import { useEffect } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import type { AppProps } from 'next/app';
import Script from 'next/script';
import 'styles/globals.scss';
import { appWithTranslation } from 'next-i18next';
import { NoticeContextProvider } from 'contexts/notification';
import { AppContextProvider } from 'contexts';
import { CartContextProvider } from 'contexts/cartContext';
import { AddedToCartContextProvider } from 'contexts/addedToCartContext';

const GTAG_ID = 'AW-18186674735';

const queryClient = new QueryClient();

const MyApp = ({ Component, pageProps }: AppProps) => {
  // Take manual control of scroll restoration so the browser doesn't jump to a
  // stale scroll position on Back before async-loaded content is ready. Pages
  // that need to restore position (e.g. paginated listings) do it themselves.
  useEffect(() => {
    if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  return (
  <QueryClientProvider client={queryClient}>
    <NoticeContextProvider>
      <AppContextProvider>
        <CartContextProvider>
          <AddedToCartContextProvider>
            <Script
              src={`https://www.googletagmanager.com/gtag/js?id=${GTAG_ID}`}
              strategy='afterInteractive'
            />
            <Script id='gtag-init' strategy='afterInteractive'>
              {`
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());
                gtag('config', '${GTAG_ID}');
              `}
            </Script>
            <Component {...pageProps} />
          </AddedToCartContextProvider>
        </CartContextProvider>
      </AppContextProvider>
    </NoticeContextProvider>
  </QueryClientProvider>
  );
};

export default appWithTranslation(MyApp);
